const SendIcon = ({ color }: any) => {
  return (
    <svg
      width="28"
      height="27"
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3166 13.5041H3.90797M3.64128 14.7974L2.08685 19.6667C1.23549 22.3335 0.809816 23.6669 1.1153 24.4879C1.38058 25.2011 1.95035 25.7417 2.65342 25.9475C3.46301 26.1844 4.68582 25.6073 7.13143 24.4534L22.8101 17.0548C25.1972 15.9282 26.3908 15.3651 26.7596 14.5827C27.0801 13.9029 27.0801 13.1052 26.7596 12.4254C26.3908 11.6432 25.1972 11.0799 22.8101 9.95342L7.10439 2.5421C4.66614 1.39153 3.44703 0.816238 2.63824 1.05224C1.93584 1.25719 1.36613 1.79637 1.09992 2.50813C0.793386 3.32772 1.21451 4.65824 2.05679 7.31928L3.6443 12.3349C3.78895 12.7919 3.86129 13.0205 3.88984 13.2541C3.91518 13.4616 3.91491 13.6716 3.88908 13.8789C3.85995 14.1125 3.78706 14.3408 3.64128 14.7974Z"
        stroke={color ? color : "#35D4AE"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SendIcon;
